import React, {useEffect, useState} from 'react';

const StatusEnum = [
  "off",
  "on",
  "pending",
  "syncing"
]

export default function StatusToggle({title, trackedValue, toggleFunction, className, disabled}) {

  const [status, setStatus] = useState(trackedValue || 0);

  const handleChange = async(evt) => {
    let newValue = evt.target.checked ? 1 : 0;
    setStatus(2);
    if(toggleFunction) {
      toggleFunction(newValue).then(success => {
        if(success) {
          setStatus(newValue);
        } else {
          setStatus(1 - newValue);
        }
      }).catch(err => {
        setStatus(1 - newValue);
      })
    } else {
      setStatus(newValue);
    }
  }

  useEffect(() => {
    setStatus(trackedValue);
  }, [trackedValue]);
  
  return <label title={title} className={`StatusToggle is-${StatusEnum[status]} ${className}`}>
    <input type="checkbox" checked={status} onChange={handleChange} disabled={status > 1 || disabled}/>
    <span className="StatusToggle-inner"></span>
  </label>

}